(function(){
  var tmpl=document.getElementById('tfc-ups-template');if(!tmpl)return;
  var form=document.querySelector('form.js-product-form-main')||document.querySelector('form.js-product-form');
  var cartAdd=(window.theme&&theme.routes&&theme.routes.cartAdd)||'/cart/add';
  var cartUrl=(window.theme&&theme.routes&&theme.routes.cart)||'/cart';
  var cartIds=null;

  function refreshCartIds(){
    return fetch(cartUrl+'.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(c){
      cartIds={};c.items.forEach(function(i){cartIds[i.product_id]=true;});applyFilterAll();
    }).catch(function(){});
  }
  function inCart(card){if(!cartIds)return false;return !!cartIds[card.getAttribute('data-product-id')];}
  function applyFilter(container){
    var vis=0;
    container.querySelectorAll('[data-ups-card]').forEach(function(card){
      if(inCart(card)){card.style.display='none';}else{card.style.display='';vis++;}
    });
    return vis;
  }
  function hideEmptyLists(scope){
    [['[data-ups-set]','[data-ups-set-hd]'],['[data-ups-extra]','[data-ups-extra-hd]']].forEach(function(p){
      var list=scope.querySelector(p[0]),hd=scope.querySelector(p[1]);
      if(!list)return;
      var vis=0;list.querySelectorAll('[data-ups-card]').forEach(function(c){if(c.style.display!=='none')vis++;});
      list.style.display=vis>0?'':'none';if(hd)hd.style.display=vis>0?'':'none';
    });
  }
  function applyFilterAll(){
    document.querySelectorAll('[data-tfc-ups-embed]').forEach(function(b){b.style.display=applyFilter(b)>0?'':'none';});
    document.querySelectorAll('[data-tfc-ups-popup] [data-tfc-ups]').forEach(function(p){applyFilter(p);hideEmptyLists(p);});
  }
  function availableCount(){
    var n=0;tmpl.content.querySelectorAll('[data-ups-card]').forEach(function(c){if(!inCart(c))n++;});return n;
  }

  function addToCart(id,prop,open,pid){
    var fd=new FormData();fd.append('id',id);fd.append('quantity',1);
    if(prop)fd.append('properties[Lieferzeit]',prop);
    fd.append('sections','cart-icon-bubble');fd.append('sections_url',location.pathname);
    return fetch(cartAdd,{method:'POST',headers:{'Accept':'application/javascript','X-Requested-With':'XMLHttpRequest'},body:fd})
      .then(function(r){if(!r.ok)throw new Error('cart '+r.status);return r.json();}).then(function(d){
        if(d&&d.status)throw new Error('cart '+d.status);
        if(cartIds&&pid)cartIds[pid]=true;
        fetch(cartUrl+'/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({attributes:{_upsell:'true'}})}).catch(function(){});
        var b=document.getElementById('cart-icon-bubble');
        if(b&&d.sections&&d.sections['cart-icon-bubble'])b.innerHTML=d.sections['cart-icon-bubble'];
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
        if(open)document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));
      });
  }
  function wire(card){
    var vs=[];try{vs=JSON.parse(card.getAttribute('data-variants'));}catch(e){}
    var sel=card.querySelector('[data-ups-size]'),dt=card.querySelector('[data-ups-del-text]'),dot=card.querySelector('.tfc-ups__dot'),btn=card.querySelector('[data-ups-add]');
    function set(id){var v=vs.filter(function(x){return String(x.id)===String(id);})[0];if(!v)return;card.setAttribute('data-current',v.id);card.setAttribute('data-prop',v.prop||'');if(dt)dt.textContent=v.line||'';if(dot)dot.classList.toggle('tfc-ups__dot--ok',(v.line||'').toLowerCase().indexOf('direct')>-1);}
    if(sel)sel.addEventListener('change',function(){set(sel.value);});
    if(btn)btn.addEventListener('click',function(){
      if(btn.classList.contains('is-added')||btn.disabled)return;
      var inPop=!!card.closest('[data-tfc-ups-popup]');
      btn.disabled=true;btn.textContent='Wird hinzugefügt...';
      addToCart(card.getAttribute('data-current'),card.getAttribute('data-prop')||'',!inPop,card.getAttribute('data-product-id'))
        .then(function(){btn.disabled=false;btn.classList.add('is-added');btn.textContent='Hinzugefügt ✓';})
        .catch(function(){btn.disabled=false;btn.textContent='Erneut versuchen';});
    });
  }
  function build(){return tmpl.content.firstElementChild.cloneNode(true);}

  // Embedded = ALLEEN set-stukken (extra's weghalen)
  if(form&&!document.querySelector('[data-tfc-ups-embed]')){
    var node=build();node.setAttribute('data-tfc-ups-embed','');
    node.querySelectorAll('[data-ups-extra],[data-ups-extra-hd]').forEach(function(el){el.remove();});
    // v488 (Tom 06-10: "een halve seconde een leeg upsell blok"): zonder set-producten niets plaatsen
    if(node.querySelector('[data-ups-card]')){
      var pf=form.closest('product-form')||form;pf.parentNode.insertBefore(node,pf.nextSibling);
      node.querySelectorAll('[data-ups-card]').forEach(wire);
    }
  }

  // Hoofdproduct toevoegen via het product-formulier (eigen fetch), ZONDER de drawer te openen.
  // Candy-Rack-volgorde: eerst toevoegen, dan pas de upsell-pop-up tonen. Geen her-submit (geen race).
  function addMain(){
    var fd=new FormData(form);
    fd.append('sections','cart-icon-bubble');fd.append('sections_url',location.pathname);
    return fetch(cartAdd,{method:'POST',headers:{'Accept':'application/javascript','X-Requested-With':'XMLHttpRequest'},body:fd})
      .then(function(r){if(!r.ok)throw new Error('cart '+r.status);return r.json();}).then(function(d){
        if(d&&d.status)throw new Error('cart '+d.status);
        if(cartIds&&d&&d.product_id)cartIds[d.product_id]=true;
        var b=document.getElementById('cart-icon-bubble');
        if(b&&d.sections&&d.sections['cart-icon-bubble'])b.innerHTML=d.sections['cart-icon-bubble'];
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
        return d;
      });
  }

  // Pop-up = set-stukken + extra's
  function openPop(){
    var ov=document.createElement('div');ov.className='tfc-ups-pop';ov.setAttribute('data-tfc-ups-popup','');
    ov.innerHTML='<div class="tfc-ups-pop__box" role="dialog" aria-modal="true"><button class="tfc-ups-pop__x" aria-label="Schließen">&times;</button><div class="tfc-ups-pop__bd"></div><div class="tfc-ups-pop__ft"><button class="tfc-ups-pop__skip">Nein, danke</button><button class="tfc-ups-pop__go">Weiter zum Warenkorb</button></div></div>';
    var inner=build();ov.querySelector('.tfc-ups-pop__bd').appendChild(inner);
    document.body.appendChild(ov);document.body.classList.add('overflow');
    inner.querySelectorAll('[data-ups-card]').forEach(wire);applyFilter(inner);hideEmptyLists(inner);
    function close(){ov.remove();document.body.classList.remove('overflow');}
    // Hoofdproduct is al toegevoegd (addMain). Sluiten = pop-up dicht (product staat in de cart);
    // 'Weiter zum Warenkorb' opent de cart-drawer.
    function goCart(){close();document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:open'));}
    ov.querySelector('.tfc-ups-pop__x').onclick=close;
    ov.querySelector('.tfc-ups-pop__skip').onclick=close;
    ov.querySelector('.tfc-ups-pop__go').onclick=goCart;
    ov.addEventListener('click',function(e){if(e.target===ov)close();});
    requestAnimationFrame(function(){ov.classList.add('is-open');});
  }
  if(form){
    form.addEventListener('submit',function(evt){
      if(form.dataset.tfcPassed==='1'){form.dataset.tfcPassed='';return;}
      if(availableCount()===0)return;
      evt.preventDefault();evt.stopImmediatePropagation();
      addMain().then(openPop).catch(function(){form.dataset.tfcPassed='1';if(form.requestSubmit)form.requestSubmit();else form.submit();});
    },true);
  }
  refreshCartIds();
})();
